import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type OrgRoleFilterFragment = { id: string, name: string, track?: { id: string, name: string, isAutomaticTrack: boolean } | null };


export type OrgRoleFilterFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const OrgRoleFilterFragmentDoc = /*#__PURE__*/ gql`
    fragment OrgRoleFilter on OrgRoleType {
  id
  name
  track {
    id
    name
    isAutomaticTrack
  }
}
    `;